import { Link } from "react-router-dom";
import { SITE, IMAGES, telLink } from "../data/siteConfig";
import { useSEO } from "../components/SEO";
import FadeIn from "../components/FadeIn";
import SectionTitle from "../components/SectionTitle";
import { CallCTA, WhatsAppCTA, btnWhite, btnWhatsApp, btnPrimary } from "../components/CTAs";
import FinalCTA from "../components/FinalCTA";

const steps = [
  { n: "01", title: "Send an Enquiry", desc: "Contact us by phone, WhatsApp or the online form." },
  { n: "02", title: "Share Your Requirements", desc: "Tell us the test or service you are looking for." },
  { n: "03", title: "Confirm Availability", desc: "Our team confirms the applicable collection details." },
  { n: "04", title: "Sample Collection", desc: "Sample collection is arranged according to the confirmed details." },
];

const HomeCollectionPage = () => {
  useSEO(
    "Home Sample Collection in Bhopal | Diagnostic Services",
    "Enquire about home sample collection in Bhopal. Contact Dr Lal PathLabs Collection Center for availability in your area. Call 8959830932."
  );

  return (
    <div>
      <section className="relative overflow-hidden bg-[#0B3056]">
        <img src={IMAGES.homeCollection} alt="Healthcare professional collecting a sample from a patient at home" className="absolute inset-0 h-full w-full object-cover opacity-25" />
        <div className="relative mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8">
          <FadeIn className="max-w-2xl">
            <p className="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-blue-200">Home Sample Collection in Bhopal</p>
            <h1 className="font-heading text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
              Diagnostic Sample Collection at Your Convenience
            </h1>
            <p className="mt-4 text-base text-blue-100 md:text-lg">
              Prefer to have your sample collected from home? Contact our collection center to enquire about home
              sample collection availability in your area of Bhopal.
            </p>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:flex-wrap">
              <Link to="/book-a-test?type=home" data-testid="home-collection-request-button" className={btnWhite}>Request Home Collection</Link>
              <CallCTA label={`Call: ${SITE.phone}`} className={btnPrimary} testId="home-collection-call-button" />
              <WhatsAppCTA message="Hello, I would like to enquire about home sample collection at Dr Lal PathLabs Collection Center, Bhopal." className={btnWhatsApp} testId="home-collection-whatsapp-button" />
            </div>
          </FadeIn>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8">
        <SectionTitle overline="The Process" title="Get Your Samples Collected From Home" subtitle="A simple, patient-friendly process from enquiry to collection." align="center" />
        <div className="grid gap-8 md:grid-cols-4">
          {steps.map((s, i) => (
            <FadeIn key={s.n} delay={i * 0.08}>
              <div className="flex h-full flex-col items-center rounded-2xl border border-gray-100 bg-white p-7 text-center shadow-sm">
                <span className="flex h-14 w-14 items-center justify-center rounded-full bg-[#1E88E5] font-heading text-lg font-extrabold text-white">
                  {s.n}
                </span>
                <h2 className="mt-4 font-heading text-lg font-bold text-[#0B3056]">{s.title}</h2>
                <p className="mt-2 text-sm text-slate-600">{s.desc}</p>
              </div>
            </FadeIn>
          ))}
        </div>
        <FadeIn className="mt-10 rounded-2xl bg-[#F0F7FA] p-6">
          <p className="text-sm leading-relaxed text-slate-600">
            Home sample collection availability, timings and service areas are confirmed by the collection center for
            each enquiry. Please{" "}
            <a href={telLink} className="font-semibold text-[#1E88E5]" data-testid="home-collection-note-call">call {SITE.phone}</a>{" "}
            or message us on WhatsApp to check availability for your location.
          </p>
        </FadeIn>
      </section>

      <FinalCTA heading="Request Home Sample Collection" text="Send your enquiry and our team will confirm availability and collection details for your area." />
    </div>
  );
};

export default HomeCollectionPage;
